
import Vue from 'vue';
import Touchy from '@/extensions/libs/Touchy'

/**
 * # v-touchy
 * 
 * Trigger touch-based events on elements.
 * 
 * Attaches eventListeners to WINDOW - which makes it react to events
 * that are blocked by other elements, i.e. sliders. Workaround because
 * swipe-events could not be detected on the flickity-slider.
 * 
 * ```
 * <div v-touchy>...</div>
 * <div v-touchy.config="{elasticDuration:0.8, swipeDownThreshold:100, swipeUpThreshold:20, prepare:initFunc, enable:checkEnableFunc}">...</div>
 * <div v-touchy:prepare="onPrepareTouch">...</div>
 * <div v-touchy:start="onTouchStart">...</div>
 * <div v-touchy:elastic="onElastic">...</div>
 * <div v-touchy:move="onTouchMove">...</div>
 * <div v-touchy:end="onTouchEnd">...</div>
 * <div v-touchy:click="onClick">...</div>
 * <div v-touchy:clickoutside="onClickOutside">...</div>
 * <div v-touchy:longpress="duringLongPress">...</div>
 * <div v-touchy:long="onLongPress">...</div>
 * <div v-touchy:cancellong="onLongPressCancelled">...</div>
 * <div v-touchy:swipeup="onSwipeUp">...</div>
 * ```
 * 
 * 
 * Parameters for `v-touchy.config`:
 * 
 * `prepare`			function called directly after `touch`, but before `enable` is checked
 * `enable`				function to test, if onStartMove() will suceed
 * `elasticDuration`	duration in seconds for snap-back effect
 * `elasticEasing`		algorithm for snap-back effect (see https://greensock.com/docs/v2/Easing)
 * `swipeThreshold`		how many pixels to move in a direction before `swipe` event is triggered
 * `swipeUpThreshold`	same, but specific for swipeUp (... down, left, right)
 * `elasticThreshold`	min distance to move before triggering `elastic`
 * `triggerOnMove`		`true` triggers swipe-events during drag, `false` waits for touchEnd before triggering
 * `outside`			`true` if events can be triggered outside of element (no need to click on element)
 * `longpressTime`		milliseconds to wait before triggering the `v-touchy:long` event
 * `clickThreshold`		distance that mouse can be moved, but mouseup will still be interpreted as click
 * 
 * (see `createConfigurationForElement()` for defaults)
 * 
 * @class extensions_directives_touchy 
 */
Vue.directive('touchy', {
	
	isFn: true,

	inserted( $el, binding, vnode ) {

		var touchy = new Touchy.watch( $el );

		// Override configuration, if `v-touchy.configuration="{...}"` is set.
		if (binding.modifiers.configuration) {
			touchy.configure(binding.value);
			return;
		}
		touchy[binding.arg]( binding.value );
	},

	unbind( $el, binding, vnode ) {
		var touchy = new Touchy.watch( $el );
		touchy.unbind();
	}
})
